const mutations = {
  setModels(state, data) {
    state.docenteCursados = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.docenteCursado = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.docenteCursados.unshift(model);
  },

  updateModel(state, model) {
    const index = state.docenteCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.docenteCursados.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.docenteCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.docenteCursados.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
